
import colors from '../colors.json';
export default {
  props: {
    clickable: {
      type: Boolean,
      default: true
    },

    small: {
      type: Boolean,
      default: false
    },

    /**
     * @values colors
     */
    type: {
      /** @type {AlturaColors} */
      type: String,
      required: false,
      default: 'primary-500',
      validator: input => colors.includes(input)
    },
    size: {
      type: [Number, String],
      default: 1
    }
  },
  methods: {
    goToIndex () {
      if (this.clickable) { this.$router.push('/'); }
    }
  }
};
